<template>
    
    <div class="main">
        <c-panel>
            <form-suporte :paramId="$route.params.id" v-on:onSubmitSuporte="onSubmitSuporte"></form-suporte>
        </c-panel>
    </div>
    
</template>
<script>

import formSuporte from "./form"

export default {
    methods:{

        onSubmitSuporte(){

            this.$router.push('/admin/suporte');  
        }
    },
    components:{ formSuporte }
}
</script>
